import BaseApi from '@/api/BaseApi';
import type { IUser, IUserAddCardRequest } from '@/models/UserModel';
import type { IPaginate } from '@/models/TableSettingsModel';
import { ROLE_ID_ADMIN_WHOLESALER } from '@/hooks/UserHooks';

export default class UserApi extends BaseApi {
	async user () {
		return this.get<IUser>({
			url: '/api/me',
		});
	};

	async adminList () {
		return this.get<IPaginate<IUser>>({
			url: `/api/users?page=1&per_page=100&role=${ROLE_ID_ADMIN_WHOLESALER}`,
		});
	};

	async addCard (payload: IUserAddCardRequest) {
		return this.post<IUserAddCardRequest, any>({
			url: '/api/card',
            data: payload,
		});
	};
};
